import type { IAppointmentConfig } from '@bb/domain/dist/types';
import axios from 'axios';
import { featureEnabled } from 'utils';
import { zustandAppointmentConfigStore } from '../../zustandStores/appointmentConfigStore';

const isAppointmentConfigCacheImplementationEnabled = () =>
  featureEnabled('appointmentConfigCachePerformanceImprovement', 1);

export const invalidateListingAppointmentConfigCache: (
  listingId?: string,
) => void = (listingId?: string): void => {
  if (!isAppointmentConfigCacheImplementationEnabled()) {
    return;
  }

  zustandAppointmentConfigStore
    .getState()
    .invalidateAppointmentConfigCache(listingId);
};

const getListingAppointmentConfig = async (
  listingId: string,
): Promise<IAppointmentConfig> => {
  if (!isAppointmentConfigCacheImplementationEnabled()) {
    const { data: appointmentConfig } = await axios.get(
      `/listing/${listingId}/appointments/config`,
    );

    return appointmentConfig;
  }

  const { appointmentConfigPromises, setAppointmentConfigPromise } =
    zustandAppointmentConfigStore.getState();

  const cachedRequest = appointmentConfigPromises[listingId];
  if (cachedRequest) {
    return cachedRequest;
  }

  const request = (async (): Promise<IAppointmentConfig> => {
    try {
      const { data: appointmentConfig } = await axios.get(
        `/listing/${listingId}/appointments/config`,
      );
      return appointmentConfig;
    } catch (error) {
      invalidateListingAppointmentConfigCache(listingId);
      throw error;
    }
  })();

  setAppointmentConfigPromise(listingId, request);

  return request;
};

export default getListingAppointmentConfig;
